/**
 * KAN-1044 — a data-free ping channel that DROPPED and came back may have missed
 * pings, so its owner re-checks ONCE (its existing single refresh — never a full
 * dashboard reload, no 30s floor). The first SUBSCRIBED is the initial attach and
 * does nothing; only SUBSCRIBED after CLOSED / CHANNEL_ERROR / TIMED_OUT fires.
 *
 * @param {() => void} onResync
 * @returns {(status: string) => void} pass to `.subscribe(...)`
 */
export function resyncOnResubscribe(onResync) {
  let down = false;
  return (status) => {
    if (status === 'CLOSED' || status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') { down = true; return; }
    if (status !== 'SUBSCRIBED' || !down) return;
    down = false;
    try { onResync(); } catch { /* never break the channel */ }
  };
}

export default resyncOnResubscribe;
